import { createSelector } from 'reselect'
import slideDataSelector from 'redux/selectors/student/slide_data_selector'
import slideTypes from 'helpers/enums/slideTypes'

const getSlideData = (state, slideId) => slideDataSelector(state, slideId)

const getOeqFormattedData = slideData => [slideData.plainTextTitle]

const getQuizFormattedData = slideData => {
	const response = []
	const question = slideData.questions[slideData.currentQuestionIndex]
	response.push(question.plainTextTitle)
	question.options.forEach((option, index) => {
		const label = String.fromCharCode(65 + index)
		response.push(`${label}. ${option.text}`)
	})
	return response
}

const getDrawItFormattedData = slideData => [slideData.title]

const getPollFormattedData = slideData => {
	const response = []
	response.push(slideData.plainTextTitle)
	slideData.options.forEach((option, index) => {
		const label = String.fromCharCode(65 + index)
		response.push(`${label}. ${option.text}`)
	})
	return response
}

export default createSelector(
	[ getSlideData ],
	slideData => {
		switch (slideData.type) {
			case slideTypes.SLIDE_TYPE_ID_OPEN_ENDED_QUESTION:
				return getOeqFormattedData(slideData)
			case slideTypes.SLIDE_TYPE_ID_POLL:
				return getPollFormattedData(slideData)
			case slideTypes.SLIDE_TYPE_ID_QUIZ:
				return getQuizFormattedData(slideData)
			case slideTypes.SLIDE_TYPE_ID_DRAW_IT:
				return getDrawItFormattedData(slideData)
			default:
				return []
		}
	}
)
